﻿export { Layerbase };
import View from 'ol/View.js';
import Map from 'ol/Map.js';
import { defaults as defaultControls } from 'ol/control.js';
import TileLayer from 'ol/layer/Tile.js';
import ImageLayer from 'ol/layer/Image.js';
import TileWMS from 'ol/source/TileWMS.js';
import ImageWMS from 'ol/source/imageWMS.js';
import ImageStatic from 'ol/source/ImageStatic.js';
import WMTSTileGrid from 'ol/tilegrid/WMTS.js';
import TileGrid from 'ol/tilegrid/TileGrid.js';
import OSM from 'ol/source/OSM.js';
import Projection from 'ol/proj/Projection.js';
import { getWidth, getTopLeft, getCenter } from 'ol/extent.js';
import WMTSCapabilities from 'ol/format/WMTSCapabilities.js';
import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS.js';
import { Utility } from '../../../lib/sgs/Utility.js';
import XYZ from 'ol/source/XYZ';
/*import ImageZoom from '../../../lib/node_modules/js-image-zoom/js-image-zoom.js'*/

const Layerbase = function (Settings) {
	//declare this
	var myLayerBase = this;

    // -- begin private variable ------------------------------------------------------------------

    // Settings
	this._settings = Settings;

    // map
    this._map = null;

    // Map
    this._mapSgs = null;

    // Utility
    this._utility = new Utility();

    // layer base Array
    this._arrayIdLayerbase = [];

    // Legend canvas variable
    this._imageLegendCanvas = null;
    this._eventLegendCanvasStart = null;
    this._eventLegendCanvasMove = null;
    this._eventLegendCanvasEnd = null;
    this._legendCanvas = null;
    this._legendCanvasCtx = null;
    this._legendCanvasDragStartPoint = null;
    this._legendCanvasDragged = null;
    this._legendCanvasLastX = null;
    this._legendCanvasLastY = null;
    this._legendCanvasScaleFactor = 1.1;
    this._legendCanvasHasCanvasActive = false;
    this._legendCanvasZoomFactor = 3;
    this._legendCanvasNewPercentLeft = 0;
    this._legendCanvasNewPercentLeftFactor = 5;

    // Legend canvas  slider zoon
    this._legendCanvasZoomSlider = document.querySelector("#id-base-map-legend-img-zoom-slider");
    this._legendCanvasZoomBar = document.querySelector("#id-base-map-legend-img-zoom-bar");

    // Result WMST GetCapabilities
    //this._resultWmtsGetCapabilities = {};

    // -- end private variable --------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Add base layer 
     * @param {MapSgs} mapSgs, Map sgs class
     * @param {object} baseLayerData, base layer data
     */
    this.AddLayerbase = function (mapSgs, baseLayerData) {

        // Map
        myLayerBase._mapSgs = mapSgs;
        myLayerBase._map = mapSgs.map;

        // Pre init canvas
        myLayerBase._PreInitLegendCanvas();

        // Build tree map base layer
        for (var i = 0; i < baseLayerData.length; i++) {
            var baseLayerObj = baseLayerData[i];
            baseLayerObj.id = 'base_' + baseLayerObj.id;
            var checked = baseLayerObj.checked ? "checked" : "";
            var input = $('<input id="' + baseLayerObj.id + '" name="base_layer" type="radio" class="base-layer-group with-gap radio-col-deep-orange" ' + checked + ' />');
            var label = $('<label style="width: 300px;" for="' + baseLayerObj.id + '">' + baseLayerObj.text + '</label>');
            $('#base-layer-theme').append(input).append(label);
            myLayerBase._BaseLayerTreeMap(myLayerBase._map, baseLayerObj);
        }

        // Event on select/unselect base layer
        $('.base-layer-group').on('click', function () {
            var idLayer = this.id;

            // Set invisible all layer base except selected one
            var layer = null;
            for (var i = 0; i < myLayerBase._arrayIdLayerbase.length; i++) {
                var idLayerArray = myLayerBase._arrayIdLayerbase[i];
                layer = myLayerBase._utility.GetLayerById(myLayerBase._map, idLayerArray);
                if (idLayerArray === idLayer)
                    layer.setVisible(true);
                else
                    layer.setVisible(false);
            }

            // Legend
            var baseMapInfo = myLayerBase._settings.baseMap.find(c => c.id == idLayer);
            if (baseMapInfo && baseMapInfo.legend_img) {

                var imageUrl = "/images/" + baseMapInfo.legend_img;
                $('#id-base-map-legend-img').removeClass('ol-hidden');

                myLayerBase._ReLoadCanvas(location.origin + imageUrl);
                myLayerBase._legendCanvasHasCanvasActive = true;
            }
            else {
                $('#id-base-map-legend-img').addClass('ol-hidden');
                myLayerBase._legendCanvasHasCanvasActive = false;
            }

            myLayerBase._map.renderSync();
        });
	};

    /**
     * Add base layer with image
     * @param {MapSgs} mapSgs, Map sgs class
     * @param {object} baseLayerData, base layer data
     */
    this.AddLayerbaseImg = function (mapSgs, baseLayerData) {

        // Map
        myLayerBase._mapSgs = mapSgs;
        myLayerBase._map = mapSgs.map;

        // Div row
        var elementBaseLayerDivRow = document.createElement('div');
        elementBaseLayerDivRow.className = "row";
        $('#base-layer-theme-img').append(elementBaseLayerDivRow);

        // For all layer base
        for (var i = 0; i < baseLayerData.length; i++) {
            var baseLayerObj = baseLayerData[i];
            var baseLayerType = baseLayerObj.kind + ":" + baseLayerObj.text;
            var idBaselayer = "";
            var srcImg = "";
            var title = "";
            switch (baseLayerType) {
                case "XYZ:Open Street Maps":
                    idBaselayer = "id-base-layer-osm";
                    srcImg = "/images/FotoOpenStreet.png";
                    title = "Open Street Maps";
                    break;
                case "GEOSERVER:Ortos 2015":
                    idBaselayer = "id-base-layer-orto";
                    srcImg = "/images/FotoOrtos.png";
                    title = "Satélite";
                    break;
                case "XYZ:Esri.WorldImagery":
                    idBaselayer = "id-base-layer-Esri.WorldImagery";
                    srcImg = "/images/FotoEsri.WorldImagery.png";
                    title = "WorldImagery";
                    break;
                case "XYZ:CartoDB.Positron":
                    idBaselayer = "id-base-layer-CartoDB.Positron";
                    srcImg = "/images/FotoCartoDB.Positron.png";
                    title = "Positron";
                    break;
                default:
                // Do nothing
            }

            // Build div col
            var elementBaseLayerDivCol = document.createElement('div');
            elementBaseLayerDivCol.className = "col col-md-6 col-xs-6";
            elementBaseLayerDivRow.appendChild(elementBaseLayerDivCol);
            var elementBaseLayerA = document.createElement('a');
            elementBaseLayerA.className = "base-layer-select";
            if (baseLayerObj.checked)
                elementBaseLayerA.className += " selected";
            elementBaseLayerA.setAttribute("type", baseLayerType);
            elementBaseLayerA.id = idBaselayer;
            elementBaseLayerA.setAttribute("id-layer", baseLayerObj.id);
            elementBaseLayerDivCol.appendChild(elementBaseLayerA);
            var elementBaseLayerImg = document.createElement('img');
            elementBaseLayerImg.setAttribute('src', srcImg);
            elementBaseLayerImg.className = "base-layer-img"
            elementBaseLayerA.appendChild(elementBaseLayerImg);
            var elementBaseLayerTitle = document.createElement('label');
            if (myLayerBase._utility.mobilecheck())
                elementBaseLayerTitle.className = "base-layer-label mobile";
            else
                elementBaseLayerTitle.className = "base-layer-label";
            elementBaseLayerTitle.innerHTML = title;
            elementBaseLayerDivCol.appendChild(elementBaseLayerTitle);

            myLayerBase._BaseLayerTreeMap(myLayerBase._map, baseLayerObj);
        }

        // Event on select/unselect base layer
        $('.base-layer-select').on('click', function () {
            var idLayer = parseInt(this.getAttribute('id-layer'));

            if ($(this).hasClass('selected'))
                return;

            for (var i = 0; i < $('.base-layer-select').length; i++) {
                var elementBaseLayer = $('.base-layer-select')[i];
                var idLayerCurrent = parseInt(elementBaseLayer.getAttribute('id-layer'));
                var layer = myLayerBase._utility.GetLayerById(myLayerBase._map, idLayerCurrent);
                if (idLayerCurrent === idLayer)
                    layer.setVisible(true);
                else
                    layer.setVisible(false);
            }

            // Clean all selection
            $('.base-layer-select').removeClass('selected');

            // Set selected
            $(this).addClass('selected');

            // if mobile leave canvas to show event occurrence in map
            if (myLayerBase._utility.mobilecheck())
                myLayerBase._utility.ShowOpenCanvas3('offcanvas-theme', false);

            myLayerBase._map.renderSync();
        });
    };

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Legend canvas, reset slider
     */
    this._LegendCanvasResetSlider = function () {
        // Reset slider to initial position
        myLayerBase._legendCanvasNewPercentLeft = 0;
        myLayerBase._legendCanvasZoomSlider.style.left = myLayerBase._legendCanvasNewPercentLeft + "%";

        // Remove event
        myLayerBase._legendCanvasZoomSlider.removeEventListener("mousedown", myLayerBase._LegendCanvasSliderInit);
        myLayerBase._legendCanvasZoomBar.removeEventListener("mousedown", myLayerBase._LegendCanvasSliderInit);

        // Add event
        myLayerBase._legendCanvasZoomSlider.addEventListener("mousedown", myLayerBase._LegendCanvasSliderInit);
        myLayerBase._legendCanvasZoomBar.addEventListener("mousedown", myLayerBase._LegendCanvasSliderInit);

        // Set zoom information
        $('#id-base-map-legend-img-zoom-text').html("100%");
    }

    /**
     * Legend canvas, init slider
     * @param {any} e
     */
    this._LegendCanvasSliderInit = function (e) {
        e.preventDefault();
        document.addEventListener("mousemove", myLayerBase._LegendCanvasSliderDrag);
        document.addEventListener("mouseup", e => {
            document.removeEventListener("mousemove", myLayerBase._LegendCanvasSliderDrag);
        });
    }

    /**
     * Legend canvas, drag slider
     * @param {any} e
     */
    this._LegendCanvasSliderDrag = function (e) {
        // Calculate slider position
        let x0 = myLayerBase._legendCanvasZoomBar.getBoundingClientRect().left;
        let width = myLayerBase._legendCanvasZoomBar.offsetWidth;
        let dX = e.clientX - x0;
        let dPercent = dX / width;
        let sliderOff = myLayerBase._legendCanvasZoomSlider.offsetLeft; 

        var percentLeft = myLayerBase._utility.ValBetween(dPercent * 100, 0, 100);
        myLayerBase._legendCanvasNewPercentLeft = Math.ceil(percentLeft / myLayerBase._legendCanvasNewPercentLeftFactor) * myLayerBase._legendCanvasNewPercentLeftFactor;
        myLayerBase._legendCanvasZoomSlider.style.left = myLayerBase._legendCanvasNewPercentLeft + "%";
        let sliderPosAfter = myLayerBase._legendCanvasZoomSlider.offsetLeft;

        //console.log("[x0][" + x0 + "][width][" + width + "][e.clientX][" + e.clientX + "][dX][" + dX + "][dPercent][" + dPercent + "][sliderOff][" + sliderOff + "][sliderPosAfter][" + sliderPosAfter + "][ValBetween][" + dX / width * 100 + "][percentLeft][" + percentLeft + "]");
        //console.log("[sliderOff][" + sliderOff + "][sliderPosAfter][" + sliderPosAfter + "][percentLeft][" + percentLeft + "][_legendCanvasNewPercentLeft][" + myLayerBase._legendCanvasNewPercentLeft + "]");

        // Zoom in or out image
        if (sliderPosAfter != sliderOff) {
            $('#id-base-map-legend-img-zoom-text').html((myLayerBase._legendCanvasNewPercentLeft + 100) + "%");
            myLayerBase._CanvasZoom((sliderPosAfter > sliderOff) ? myLayerBase._legendCanvasZoomFactor : -1 * myLayerBase._legendCanvasZoomFactor);
        }
    }

    /**
     * Legend canvas, build context transform function
     * @param {any} ctx, canvas context
     */
    this._CanvasTrackTransforms = function (ctx) {
        var svg = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
        var xform = svg.createSVGMatrix();
        ctx.getTransform = function () { return xform; };

        var savedTransforms = [];
        var save = ctx.save;
        ctx.save = function () {
            savedTransforms.push(xform.translate(0, 0));
            return save.call(ctx);
        };

        var restore = ctx.restore;
        ctx.restore = function () {
            xform = savedTransforms.pop();
            return restore.call(ctx);
        };

        var scale = ctx.scale;
        ctx.scale = function (sx, sy) {
            xform = xform.scaleNonUniform(sx, sy);
            return scale.call(ctx, sx, sy);
        };

        var rotate = ctx.rotate;
        ctx.rotate = function (radians) {
            xform = xform.rotate(radians * 180 / Math.PI);
            return rotate.call(ctx, radians);
        };

        var translate = ctx.translate;
        ctx.translate = function (dx, dy) {
            xform = xform.translate(dx, dy);
            return translate.call(ctx, dx, dy);
        };

        var transform = ctx.transform;
        ctx.transform = function (a, b, c, d, e, f) {
            var m2 = svg.createSVGMatrix();
            m2.a = a; m2.b = b; m2.c = c; m2.d = d; m2.e = e; m2.f = f;
            xform = xform.multiply(m2);
            return transform.call(ctx, a, b, c, d, e, f);
        };

        var setTransform = ctx.setTransform;
        ctx.setTransform = function (a, b, c, d, e, f) {
            xform.a = a;
            xform.b = b;
            xform.c = c;
            xform.d = d;
            xform.e = e;
            xform.f = f;
            return setTransform.call(ctx, a, b, c, d, e, f);
        };

        var pt = svg.createSVGPoint();
        ctx.transformedPoint = function (x, y) {
            pt.x = x; pt.y = y;
            return pt.matrixTransform(xform.inverse());
        }
    };

    /**
     * Legend canvas, check if device as touch capability
     */
    this._HasTouch = function () {
        return 'ontouchstart' in document.documentElement;
    };

    /**
     * Legend canvas, redraw legend canvas
     */
    this._CanvasRedraw = function () {

        // Clear the entire canvas
        var p1 = myLayerBase._legendCanvasCtx.transformedPoint(0, 0);
        var p2 = myLayerBase._legendCanvasCtx.transformedPoint(myLayerBase._legendCanvas.width, myLayerBase._legendCanvas.height);
        myLayerBase._legendCanvasCtx.clearRect(p1.x, p1.y, p2.x - p1.x, p2.y - p1.y);

        myLayerBase._legendCanvasCtx.save();
        myLayerBase._legendCanvasCtx.setTransform(1, 0, 0, 1, 0, 0);
        myLayerBase._legendCanvasCtx.clearRect(0, 0, myLayerBase._legendCanvas.width, myLayerBase._legendCanvas.height);
        myLayerBase._legendCanvasCtx.restore();

        myLayerBase._legendCanvasCtx.drawImage(myLayerBase._imageLegendCanvas, 0, 0);
    };

    /**
     * Legend canvas, start drag on mousedown
     * @param {any} evt, event
     */
    this._CanvasStartDrag = function (evt) {
        document.body.style.mozUserSelect = document.body.style.webkitUserSelect = document.body.style.userSelect = 'none';
        myLayerBase._legendCanvasLastX = evt.offsetX || (evt.pageX - myLayerBase._legendCanvas.offsetLeft);
        myLayerBase._legendCanvasLastY = evt.offsetY || (evt.pageY - myLayerBase._legendCanvas.offsetTop);
        myLayerBase._legendCanvasDragStartPoint = myLayerBase._legendCanvasCtx.transformedPoint(myLayerBase._legendCanvasLastX, myLayerBase._legendCanvasLastY);
        myLayerBase._legendCanvasDragged = false;
    };

    /**
     * Legend canvas, drag on mousemove
     * @param {any} evt
     */
    this._CanvasDragged = function (evt) {
        myLayerBase._legendCanvasLastX = evt.offsetX || (evt.pageX - myLayerBase._legendCanvas.offsetLeft);
        myLayerBase._legendCanvasLastY = evt.offsetY || (evt.pageY - myLayerBase._legendCanvas.offsetTop);
        myLayerBase._legendCanvasDragged = true;
        if (myLayerBase._legendCanvasDragStartPoint) {
            var pt = myLayerBase._legendCanvasCtx.transformedPoint(myLayerBase._legendCanvasLastX, myLayerBase._legendCanvasLastY);
            myLayerBase._legendCanvasCtx.translate(pt.x - myLayerBase._legendCanvasDragStartPoint.x, pt.y - myLayerBase._legendCanvasDragStartPoint.y);
            myLayerBase._CanvasRedraw();
        }
    };

    /**
     * Legend canvas, end drag
     * @param {any} evt
     */
    this._CanvasEndDrag = function (evt) {
        myLayerBase._legendCanvasDragStartPoint = null;
        if (!myLayerBase._legendCanvasDragged)
            myLayerBase._CanvasZoom(evt.shiftKey ? -1 : 1);
    };

    /**
     * Legend canvas, zoom
     * @param {any} clicks, factor zoom input
     */
    this._CanvasZoom = function (clicks) {
        var pt = myLayerBase._legendCanvasCtx.transformedPoint(myLayerBase._legendCanvasLastX, myLayerBase._legendCanvasLastY);
        myLayerBase._legendCanvasCtx.translate(pt.x, pt.y);
        var factor = Math.pow(myLayerBase._legendCanvasScaleFactor, clicks);

        myLayerBase._legendCanvasCtx.scale(factor, factor);
        myLayerBase._legendCanvasCtx.translate(-pt.x, -pt.y);
        myLayerBase._CanvasRedraw();

        //console.log("[a][" + myLayerBase._legendCanvasCtx.getTransform().a + "][b][" + myLayerBase._legendCanvasCtx.getTransform().b + "]-[LX][" + myLayerBase._legendCanvasLastX + "][LY][" + myLayerBase._legendCanvasLastY + "]-[pt.x][" + pt.x + "][pt.y][" + pt.y + "]");
    }

    /**
     * Legend canvas, scroll on canvas
     * @param {any} evt, event
     */
    this._CanvasHandleScroll = function (evt) {
        var delta = evt.wheelDelta ? evt.wheelDelta / 40 : evt.detail ? -evt.detail : 0; // do not use the wheeldelta, use a const to syncronize zoom by the slider and by de wheel or touchpad
        var zoomFactor = myLayerBase._legendCanvasZoomFactor

        //console.log("[myLayerBase._legendCanvasNewPercentLeft][" + myLayerBase._legendCanvasNewPercentLeft + "]")

        if (delta) {
            if ((myLayerBase._legendCanvasNewPercentLeft == 0 && delta > 0) || (myLayerBase._legendCanvasNewPercentLeft == 100 && delta < 0) || (myLayerBase._legendCanvasNewPercentLeft > 0 && myLayerBase._legendCanvasNewPercentLeft < 100)) {
                if (delta < 0) {
                    zoomFactor = zoomFactor * -1;
                    myLayerBase._legendCanvasNewPercentLeft -= myLayerBase._legendCanvasNewPercentLeftFactor;
                }
                else {
                    myLayerBase._legendCanvasNewPercentLeft += myLayerBase._legendCanvasNewPercentLeftFactor;
                }
                myLayerBase._legendCanvasZoomSlider.style.left = myLayerBase._legendCanvasNewPercentLeft + "%";

                $('#id-base-map-legend-img-zoom-text').html((myLayerBase._legendCanvasNewPercentLeft + 100) + "%");
                myLayerBase._CanvasZoom(zoomFactor)
            }
        }
        return evt.preventDefault() && false;
    };

    /**
     * Legend canvas, pre init variable
     */
    this._PreInitLegendCanvas = function () {
        myLayerBase._imageLegendCanvas = new Image;
        myLayerBase._eventLegendCanvasStart = myLayerBase._HasTouch() ? 'touchstart' : 'mousedown';
        myLayerBase._eventLegendCanvasMove = myLayerBase._HasTouch() ? 'touchmove' : 'mousemove';
        myLayerBase._eventLegendCanvasEnd = myLayerBase._HasTouch() ? 'touchend' : 'mouseup';
    };

    /**
     * Legend canvas, build canvas
     * @param {any} width
     * @param {any} height
     */
    this._InitLegendCanvas = function (width, height) {
        // Clear canvas if exists
        if (myLayerBase._legendCanvas) {
            if (myLayerBase._legendCanvasCtx) {
                myLayerBase._legendCanvasCtx.clearRect(0, 0, myLayerBase._legendCanvas.width, myLayerBase._legendCanvas.height);
            }
            const clonedCanvas = myLayerBase._legendCanvas.cloneNode(true);
            myLayerBase._legendCanvas.replaceWith(clonedCanvas);
            // Remove the cloned canvas from the DOM
            clonedCanvas.remove();
        }

        // Build canvas element
        $('#id-base-map-legend-img-canvas-zone').empty();
        $('#id-base-map-legend-img-canvas-zone').append($('<canvas id="id-base-map-legend-img-canvas" class="base-map-legend-img-canvas"></canvas>'));

        myLayerBase._legendCanvas = document.getElementById('id-base-map-legend-img-canvas');
        myLayerBase._legendCanvas.width = width;
        myLayerBase._legendCanvas.height = height;
        myLayerBase._legendCanvasCtx = myLayerBase._legendCanvas.getContext('2d');
        myLayerBase._CanvasTrackTransforms(myLayerBase._legendCanvasCtx);
        myLayerBase._legendCanvasLastX = myLayerBase._legendCanvas.width / 2;
        myLayerBase._legendCanvasLastY = myLayerBase._legendCanvas.height / 2;

        // Reset canvas
        myLayerBase._legendCanvasCtx.setTransform(1, 0, 0, 1, 0, 0);
        myLayerBase._legendCanvasCtx.clearRect(0, 0, myLayerBase._legendCanvas.width, myLayerBase._legendCanvas.height);

        // -- Begin drag event --------------------------------------------------------------------

        // Event star drag
        myLayerBase._legendCanvas.addEventListener(myLayerBase._eventLegendCanvasStart, myLayerBase._CanvasStartDrag, false);

        // Event drag
        myLayerBase._legendCanvas.addEventListener(myLayerBase._eventLegendCanvasMove, myLayerBase._CanvasDragged, false);

        // End drag
        myLayerBase._legendCanvas.addEventListener(myLayerBase._eventLegendCanvasEnd, myLayerBase._CanvasEndDrag, false);

        // -- End drag event ----------------------------------------------------------------------

        // -- Begin zoom event --------------------------------------------------------------------

        myLayerBase._legendCanvas.addEventListener('DOMMouseScroll', myLayerBase._CanvasHandleScroll, false);
        myLayerBase._legendCanvas.addEventListener('mousewheel', myLayerBase._CanvasHandleScroll, false);
    };

    /**
     * Legend canvas, reload canvas
     * @param {any} imageUrl
     */
    this._ReLoadCanvas = function (imageUrl) {
        myLayerBase._utility.ShowWait('offcanvas-map-legend-spinner', true);

        // Set image
        myLayerBase._imageLegendCanvas.src = imageUrl;
        myLayerBase._imageLegendCanvas.onload = function () {
            // Get width value from main off canvas element
            let newCanvasWidth = $('#id-base-map-legend-img').width() - 20;
            const imgWidth = myLayerBase._imageLegendCanvas.width;
            const imgHeight = myLayerBase._imageLegendCanvas.height;

            // Calculate the height to maintain the aspect ratio
            const aspectRatio = myLayerBase._imageLegendCanvas.height / myLayerBase._imageLegendCanvas.width;
            const newCanvasHeight = newCanvasWidth * aspectRatio;

            // Caclulatre scale factor
            let scaleFactor = Math.min(newCanvasWidth / imgWidth, newCanvasHeight / imgHeight);

            // Calculate new image dimension
            const imgNewWidth = imgWidth * scaleFactor;
            const imgNewHeight = imgHeight * scaleFactor;

            // Set height value
            $('#id-base-map-legend-img').css('height', (newCanvasHeight+42) + "px");
            $('#id-base-map-legend-img-canvas-zone').css('height', newCanvasHeight + "px");

            // DPI
            const dpr = window.devicePixelRatio || 1;

            // Init slider
            myLayerBase._LegendCanvasResetSlider();

            // Init canvas
            myLayerBase._InitLegendCanvas(newCanvasWidth * dpr, newCanvasHeight * dpr);

            // Draw image on canvas
            myLayerBase._legendCanvasCtx.drawImage(myLayerBase._imageLegendCanvas, 0, 0, imgNewWidth, imgNewHeight);

            myLayerBase._legendCanvasCtx.scale(scaleFactor, scaleFactor);

            // Redraw canvas
            myLayerBase._CanvasRedraw();

            //console.log("[a][" + myLayerBase._legendCanvasCtx.getTransform().a + "][b][" + myLayerBase._legendCanvasCtx.getTransform().b + "]");

            myLayerBase._utility.ShowWait('offcanvas-map-legend-spinner', false);
        };
    }

    /**
	 * Create base layer map
     * @param {ol.map} map, map to add layer base
	 * @param {any} baselayer, base layer
	 */
    this._BaseLayerTreeMap = function (map, baselayer) {
        // For type of base layer
        switch (baselayer.kind) {
            case "GEOSERVER":
                switch (baselayer.codLayerProtocol) {
                    case "WMTS": // WMST Tile service
                        if (baselayer.codServerType == "WMTS_SERVICE") {
                            myLayerBase._AddExternalWMTSBaseLayerToMap(map, baselayer.id, baselayer.internalGeoserver, baselayer.layerName, baselayer.cqlFilter, baselayer.checked, baselayer.minScale, baselayer.maxScale);
                        }
                        else {
                            myLayerBase._AddGeoserverWMTSBaseLayerToMap(
                                map,
                                (_geoserverAccess === "internal") ? baselayer.internalGeoserver.slice(0, -1) : baselayer.geoserver,
                                (baselayer.workspace != "NONE") ? baselayer.workspace : "",
                                baselayer.layerName,
                                baselayer.cqlFilter,
                                baselayer.checked,
                                baselayer.id,
                                baselayer.minScale,
                                baselayer.maxScale,
                                baselayer.internalGeoserver.slice(0, -1)
                            );    
                        }
                        break;
                    case "WMS": // WMS Tile Service
                        if (baselayer.codServerType == "WMS_SERVICE") {
                            myLayerBase._AddWMSExternalLayerToMap(map, baselayer.id, baselayer.internalGeoserver, baselayer.layerName, baselayer.checked, baselayer.minScale, baselayer.maxScale);
                        }
                        else {
                            myLayerBase._AddGeoserverWMTSBaseLayerToMap(
                                map,
                                baselayer.id,
                                (_geoserverAccess === "internal") ? baselayer.internalGeoserver.slice(0, -1) : baselayer.geoserver,
                                (baselayer.workspace != "NONE") ? baselayer.workspace : "",
                                baselayer.layerName,
                                baselayer.cqlFilter,
                                "",
                                baselayer.checked,
                                baselayer.minScale,
                                baselayer.maxScale
                            );
                        }
                        break;
                    case "WMS_ST": // WMS service (not tile)
                        if (baselayer.codServerType == "WMS_SERVICE") {
                            myLayerBase._AddWMSSTExternalLayerToMap(map, baselayer.id, baselayer.internalGeoserver, baselayer.layerName, baselayer.checked, baselayer.minScale, baselayer.maxScale);
                        }
                        else {
                            myLayerBase._AddWMSSTLayerToMap(
                                map,
                                baselayer.id,
                                (_geoserverAccess === "internal") ? baselayer.internalGeoserver.slice(0, -1) : baselayer.geoserver,
                                (baselayer.workspace != "NONE") ? baselayer.workspace : "",
                                baselayer.layerName,
                                baselayer.cqlFilter,
                                "",
                                baselayer.checked,
                                baselayer.minScale,
                                baselayer.maxScale
                            );
                        }
                        break;
                    case "ImageEsri":
                        myLayerBase._AddImageEsriToMap(map, baselayer, -1);
                        break;
                    case "TileEsri":
                        myLayerBase._AddTileEsriToMap(map, baselayer, -1);
                        break;
                    default:
                        // Do nothing
                }
                break;
            case "XYZ":
                myLayerBase._AddGenericLayerToMap
                    (
                        map,
                        baselayer.kind,
                        baselayer.checked,
                        baselayer.id,
                        baselayer.minScale,
                        baselayer.maxScale,
                        baselayer.attribution_base_layer,
                        baselayer.url_base_layer
                    );
                break;
            default:
                // Do nothing
        }
    };

    /**
 * Add tile esri to map
     * @param {ol.map} map, map
     * @param {object} layerInfo, layer information
     * @param {int} index
     */
    this._AddTileEsriToMap = function (map, layerInfo, index) {
        var tileLayer = new TileLayer({
            name: layerInfo.workspace + ":" + layerInfo.layerName + ":" + layerInfo.id,
            gpId: layerInfo.id,
            id: 'T' + layerInfo.id,
            zIndex: index,
            visible: layerInfo.checked,
            source: new TileArcGISRest({
                ratio: 1,
                params: { 'LAYERS': 'show:' + layerInfo.layerId },
                crossOrigin: 'anonymous',
                url: layerInfo.serviceNameUrl
            }),
            minResolution: layerInfo.minScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(layerInfo.minScale)] : myLayerBase._settings.resolutions[myLayerBase._settings.resolutions.length - 1],
            maxResolution: layerInfo.maxScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(layerInfo.maxScale)] + 0.1 : myLayerBase._settings.resolutions[0]
        });

        // Add layer to map
        map.addLayer(tileLayer);
    }

    /**
     * Add image esri to map
     * @param {ol.map} map, map
     * @param {object} layerInfo, layer information
     * @param {int} index
     */
    this._AddImageEsriToMap = function (map, layerInfo, index) {
        var imgLayer = new ImageLayer({
            name: layerInfo.layerName + ":" + layerInfo.id,
            gpId: layerInfo.id,
            id: 'T' + layerInfo.id,
            zIndex: index,
            visible: layerInfo.checked,
            source: new ImageArcGISRest({
                ratio: 1,
                params: { 'LAYERS': 'show:' + layerInfo.layerId },
                crossOrigin: 'anonymous',
                url: layerInfo.serviceNameUrl
            }),
            minResolution: layerInfo.minScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(layerInfo.minScale)] : myLayerBase._settings.resolutions[myLayerBase._settings.resolutions.length - 1],
            maxResolution: layerInfo.maxScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(layerInfo.maxScale)] + 0.1 : myLayerBase._settings.resolutions[0]
        });

        // Add layer to map
        map.addLayer(imgLayer);
    }

    /**
     * Add external wms st service
     */
    this._AddWMSSTExternalLayerToMap = function (map, id, urlIn, layerName, state, minScale, maxScale) {
        var url = urlIn.split("?")[0];
        var params = { 'LAYERS': 'OrtoSat2023', 'TILED': true, 'VERSION': '1.1.1'};

        var tileLayer = new ImageLayer({
            name: layerName + ":" + id,
            zIndex: -1,
            gpId: id,
            visible: state,
            id: id,
            source: new ImageWMS({
                url: url,
                params: params,
                hidpi: false,
                transition: 0,
                crossOrigin: 'anonymous'
            }),
            minResolution: minScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(minScale)] : myLayerBase._settings.resolutions[myLayerBase._settings.resolutions.length - 1],
            maxResolution: maxScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(maxScale)] + 0.1 : myLayerBase._settings.resolutions[0]
        });

        // Add layer to map
        map.addLayer(tileLayer);
        myLayerBase._arrayIdLayerbase.push(id);
    };

    /**
     * Add single tile WMS st Layer to Map
     * @param {ol.map} map, map
     * @param {string} id, id layer
     * @param {any} geoserver, geoserver
     * @param {any} workspace, workspace
     * @param {any} layerName, layer name
     * @param {any} cqlFilter, cql filter
     * @param {string} sldName, sld name
     * @param {boolean} state, state visible
     * @param {any} minScale, min scale
     * @param {any} maxScale, max scale
     */
    this._AddWMSSTLayerToMap = function (map, id, geoserver, workspace, layerName, cqlFilter, sldName, state, minScale, maxScale) {

        var params = { 'LAYERS': workspace + ':' + layerName, 'TILED': true, 'VERSION': '1.1.1' };

        if (sldName)
            params.STYLES = workspace + ":" + sldName.replace('.sld', '');
        if (cqlFilter)
            params.cql_filter = cqlFilter;

        var tileLayer = new ImageLayer({
            name: workspace + ":" + layerName + ":" + id,
            zIndex: -1,
            gpId: id,
            visible: state,
            id: 'T' + id,
            source: new ImageWMS({
                url: geoserver + '/' + workspace + '/wms',
                params: params,
                //serverType: 'geoserver',
                ratio: 1,
                crossOrigin: 'anonymous'
            }), // ALERT: MaxResolution + 0.1 because: The maximum resolution (exclusive) below which this layer will be visible AND The minimum resolution (inclusive) at which this layer will be visible.
            minResolution: minScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(minScale)] : myLayerBase._settings.resolutions[myLayerBase._settings.resolutions.length - 1],
            maxResolution: maxScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(maxScale)] + 0.1 : myLayerBase._settings.resolutions[0]
        });

        // Add layer to map
        map.addLayer(tileLayer);
    };

    /**
     * Add external wms service
     */
    this._AddWMSExternalLayerToMap = function (map, id, urlIn, layerName, state, minScale, maxScale) {
        var url = urlIn.split("?")[0];
        var params = { 'LAYERS': layerName, 'TILED': true, 'VERSION': '1.1.1' };

        var tileLayer = new TileLayer({
            name: layerName + ":" + id,
            zIndex: -1,
            gpId: id,
            visible: state,
            id: id,
            source: new TileWMS({
                url: url,
                params: params,
                hidpi: false,
                transition: 0
            }),
            minResolution: minScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(minScale)] : myLayerBase._settings.resolutions[myLayerBase._settings.resolutions.length - 1],
            maxResolution: maxScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(maxScale)] + 0.1 : myLayerBase._settings.resolutions[0]
        });

        // Add layer to map
        map.addLayer(tileLayer);
        myLayerBase._arrayIdLayerbase.push(id);
    };

    /**
     * Add multiple tile WMS Layer to Map
     * @param {ol.map} map, map
     * @param {string} id, id layer
     * @param {any} geoserver, geoserver
     * @param {any} workspace, workspace
     * @param {any} layerName, layer name
     * @param {any} cqlFilter, cql filter
     * @param {string} sldName, sld name
     * @param {boolean} state, state visible
     * @param {any} minScale, min scale
     * @param {any} maxScale, max scale
     */
    this._AddWMSLayerToMap = function (map, id, geoserver, workspace, layerName, cqlFilter, sldName, state, minScale, maxScale) {

        var params = { 'LAYERS': workspace + ':' + layerName, 'TILED': true, 'VERSION': '1.1.1' };

        if (sldName && sldName != "")
            params.STYLES = workspace + ":" + sldName.replace('.sld', '');
        if (cqlFilter)
            params.cql_filter = cqlFilter; // + " and BBOX(geom, " + map.getView().calculateExtent().join(',') + ")";

        var matrixIds = [];
        for (var z = 0; z < myLayerBase._settings.resolutions.length; ++z) {
            matrixIds[z] = myLayerBase._settings.projection.getCode() + ":" + z;
        }

        var tileLayer = new TileLayer({
            name: workspace + ":" + layerName + ":" + id,
            zIndex: -1,
            gpId: id,
            visible: state,
            id: 'T' + id,
            source: new TileWMS({
                url: geoserver + '/' + workspace + '/wms',
                params: params,
                serverType: 'geoserver',
                hidpi: false,
                transition: 0,
                tileGrid: new TileGrid({
                    tileSize: [256, 256],
                    origin: [myLayerBase._settings.center[0], myLayerBase._settings.center[1]],
                    resolutions: myLayerBase._settings.resolutions,
                    matrixIds: matrixIds
                }),
            }),
            minResolution: minScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(minScale)] : myLayerBase._settings.resolutions[myLayerBase._settings.resolutions.length - 1],
            maxResolution: maxScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(maxScale)] + 0.1 : myLayerBase._settings.resolutions[0]
        });

        // Add layer to map
        map.addLayer(tileLayer);
    };

    /**
	 * * add Geoserver Base Layer to a Map
     * @param {ol.map} map, map to add layer base
	 * @param {any} geoserver, geoserver
	 * @param {any} workspace, workspace
	 * @param {any} layerName, layer name
	 * @param {any} cqlFilter, sql filter
	 * @param {any} state, state
	 * @param {any} id, id layer
	 * @param {any} minScale, min scale
	 * @param {any} maxScale, max scale
	 */
    this._AddGeoserverWMSBaseLayerToMap = function (map, geoserver, workspace, layerName, cqlFilter, state, id, minScale, maxScale) {
        var params = { 'LAYERS': workspace + ':' + layerName, 'TILED': true, 'VERSION': '1.1.1' };
        if (cqlFilter)
            params.cql_filter = cqlFilter + " and BBOX(geom, " + map.getView().calculateExtent().join(',') + ")";
        var tileLayer = new TileLayer({
            name: workspace + ":" + layerName,
            zIndex: -1,
            visible: state,
            id: id,
            source: new TileWMS({
                url: geoserver + '/' + workspace + '/wms',
                params: params,
                serverType: 'geoserver',
                hidpi: false,
                transition: 0
            }),
            minResolution: minScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(minScale)] : myLayerBase._settings.resolutions[myLayerBase._settings.resolutions.length - 1],
            maxResolution: maxScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(maxScale)]+0.1 : myLayerBase._settings.resolutions[0]
        });

        // Add tile layer to array
        map.addLayer(tileLayer);
        myLayerBase._arrayIdLayerbase.push(id);
    };

    /**
     * Get capabilities wmts
     * @param {string} geoserver, geoserver url prefixe
     * @param {string} internalGeoserver, internal geoserver url
     */
    this._GetCapabilitiesWmts = function (workspace, geoserver, internalGeoserver) {
        var parser = new WMTSCapabilities();
        var newUrl = window.location.origin + geoserver;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', geoserver + '/' + workspace + '/gwc/service/wmts?REQUEST=GetCapabilities', false);
        xhr.onload = function () {
            switch(_geoserverAccess) {
                case "internal":
                    myLayerBase._settings._resultWmtsGetCapabilities[workspace+geoserver] = parser.read(xhr.responseText);
                    break;
                default:
                    myLayerBase._settings._resultWmtsGetCapabilities[workspace+geoserver] = parser.read(xhr.responseText.split(internalGeoserver).join(newUrl));
            }
        };
        xhr.send();
    }

	/**
	 * Add Geoserver Base Layer to a Map
     * @param {ol.map} map, map to add layer base
	 * @param {string} geoserver, geoserver
	 * @param {string} workspace, workspace
	 * @param {string} layerName, layer name
	 * @param {string} cqlFilter, sql filter
	 * @param {string} state, state
	 * @param {string} id, id layer
	 * @param {int} minScale, min scale
	 * @param {int} maxScale, max scale
	 */
    this._AddGeoserverWMTSBaseLayerToMap = function (map, geoserver, workspace, layerName, cqlFilter, state, id, minScale, maxScale, internalGeoserver) {
        if (myLayerBase._settings._resultWmtsGetCapabilities[workspace+geoserver] === undefined) {
            myLayerBase._GetCapabilitiesWmts(workspace, geoserver, internalGeoserver);
        }

        var options = optionsFromCapabilities(myLayerBase._settings._resultWmtsGetCapabilities[workspace+geoserver], {
            layer: layerName,
            matrixSet: myLayerBase._settings.projection.getCode()
        });

        var tileLayer = new TileLayer({
            name: workspace + ":" + layerName,
            zIndex: -1,
            visible: state,
            id: id,
            source: new WMTS(/** @type {!module:ol/source/WMTS~Options} */(options)),
            minResolution: minScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(minScale)] : myLayerBase._settings.resolutions[myLayerBase._settings.resolutions.length - 1],
            maxResolution: maxScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(maxScale)]+0.1 : myLayerBase._settings.resolutions[0]
        });

        // Add tile layer to array
        map.addLayer(tileLayer);

        myLayerBase._arrayIdLayerbase.push(id);
	};

    /**
     * Get capabilities wmts by url
     * @param {string} geoserver, geoserver url prefixe
     * @param {string} internalGeoserver, internal geoserver url
     */
    this._GetCapabilitiesWmts2 = function (url) {
        var parser = new WMTSCapabilities();
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, false);
        xhr.onload = function () {
            myLayerBase._settings._resultWmtsGetCapabilities[url] = parser.read(xhr.responseText);
        };
        xhr.send();
    }

    /**
     * Add External Base Layer to a Map
     * @param {ol.map} map, map to add layer base
     * @param {string} id, id layer
     * @param {string} url, service url
     * @param {string} layerName, layer name
     * @param {string} cqlFilter, sql filter
     * @param {string} state, state
     * @param {int} minScale, min scale
     * @param {int} maxScale, max scale
     */
    this._AddExternalWMTSBaseLayerToMap = function (map, id, url, layerName, cqlFilter, state, minScale, maxScale) {
        if (myLayerBase._settings._resultWmtsGetCapabilities[url] === undefined) {
            myLayerBase._GetCapabilitiesWmts2(url);
        }

        var options = optionsFromCapabilities(myLayerBase._settings._resultWmtsGetCapabilities[url], {
            layer: layerName,
            matrixSet: myLayerBase._settings.projection.getCode()
        });

        var tileLayer = new TileLayer({
            name: layerName,
            zIndex: -1,
            visible: state,
            id: id,
            source: new WMTS(/** @type {!module:ol/source/WMTS~Options} */(options)),
            minResolution: minScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(minScale)] : myLayerBase._settings.resolutions[myLayerBase._settings.resolutions.length - 1],
            maxResolution: maxScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(maxScale)] + 0.1 : myLayerBase._settings.resolutions[0]
        });

        // Add tile layer to array
        map.addLayer(tileLayer);

        myLayerBase._arrayIdLayerbase.push(id);
    };

	/**
	 * Add geoserver layer to Map
     * @param {ol.map} map, map to add layer base
	 * @param {any} kind, kind map
	 * @param {any} state, state
	 * @param {any} id, id layer
	 * @param {any} minScale, min scale
	 * @param {any} maxScale, max scale
	 */
	this._AddGeoserverLayerToMap = function (map, kind, state, id, minScale, maxScale) {
        var tileLayer = new TileLayer({
			id: id,
			visible: state,
			zIndex: -1,
            source: new OSM(
                "Local Tiles",
                "tiles/${z}/${x}/${y}.png",
                {
                    numZoomLevels: 19,
                    alpha: true,
                    isBaseLayer: false
                }
            ),
            minResolution: minScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(minScale)] : myLayerBase._settings.resolutions[myLayerBase._settings.resolutions.length-1],
            maxResolution: maxScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(maxScale)]+0.1 : myLayerBase._settings.resolutions[0]
        });

        // Add tile layer to array
        map.addLayer(tileLayer);
        myLayerBase._arrayIdLayerbase.push(id);
    };

    /**
	 * Add geoserver generic tile layer to Map
     * @param {ol.map} map, map to add layer base
	 * @param {string} kind, kind map
	 * @param {string} state, state
	 * @param {string} id, id layer
	 * @param {double} minScale, min scale
	 * @param {double} maxScale, max scale
     * @param {string} attribution_base_layer, attribution layer definition
     * @param {string} url_base_layer, url layer
	 */
    this._AddGenericLayerToMap = function (map, kind, state, id, minScale, maxScale, attribution_base_layer, url_base_layer) {

        var tileLayer = new TileLayer({
            id: id,
            visible: state,
            zIndex: -1,
            source: new XYZ({
                attributions: attribution_base_layer,
                url: url_base_layer,
                crossOrigin: 'anonymous'
            }),
            minResolution: minScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(minScale)] : myLayerBase._settings.resolutions[myLayerBase._settings.resolutions.length - 1],
            maxResolution: maxScale ? myLayerBase._settings.resolutions[myLayerBase._settings.scales.indexOf(maxScale)]+0.1 : myLayerBase._settings.resolutions[0]
        });

        // Add tile layer to array
        map.addLayer(tileLayer);
        myLayerBase._arrayIdLayerbase.push(id);
    };

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    $('#id-base-map-legend-img-zoom-btn-reset').on("click", function () {
        if (myLayerBase._legendCanvasHasCanvasActive) {
            myLayerBase._ReLoadCanvas(myLayerBase._imageLegendCanvas.src);
        };
    });

    // -- end event -------------------------------------------------------------------------------

};